import { computed } from 'vue';
import { CustomProductTypes } from '@studyportals/campaign-management-api-interface';
import { IUnsavedCustomProductData } from '@/models/custom-products.interface';
import store from '@/store';

class CustomProductPresenter {
	private newCustomProducts = computed((): (IUnsavedCustomProductData)[] => {
		const customProducts = store.getters.customProducts();
		return customProducts.filter(
			(product) => typeof product.id === 'string'
		) as IUnsavedCustomProductData[];
	});

	public newCustomProductLabel = computed((): string => {
		const newCustomProductCount = this.newCustomProducts.value.length;
		return `new-${newCustomProductCount}`;
	});

	public retrieveLabelOfType(type: CustomProductTypes): string {
		switch (type) {
			case CustomProductTypes.ACT:
				return 'ACT';
			case CustomProductTypes.BANNER_DESIGN:
				return 'Banner Design';
			case CustomProductTypes.EMAIL:
				return 'Email';
			case CustomProductTypes.LEADS:
				return 'Leads';
			case CustomProductTypes.REMARKETING:
				return 'Remarketing';
			case CustomProductTypes.TIKTOK:
				return 'TikTok';
			case CustomProductTypes.OTHER:
				return 'Other';
			default:
				throw Error(`CustomProductPresenter.retrieveLabelOfType: invalid custom product type: ${type as string}`);
		}
	}
}

export default new CustomProductPresenter();
